import VisibleComponent from '../VisibleComponent'
import Mask from "../Mask"
import Button from "../Button"
import './index.less'

const template = `
    <div class="mtg-dialog-wrap">
        <div class="mtg-dialog-box">
            <div class="mtg-dialog-content-wrap">
                <div class="mtg-dialog-image" id="mtg-dialog-image"></div>
                <div class="mtg-dialog-title" id="mtg-dialog-title"></div>
                <div class="mtg-dialog-content" id="mtg-dialog-content"></div>
            </div>
            <div class="mtg-dialog-btn-group" id="mtg-dialog-btn-group"></div>
        </div>
    </div>
    `

/**
 * Dialog 弹窗类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Dialog extends VisibleComponent {
    constructor(options = {}) {
        super(options)
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)
        const {
            hasMask = true,
            imageUrl,
            imageSize = "1",
            title,
            content,
            buttonGroup = [],
        } = options

        this.dialogWrap = this.element;
        this.dialogImageBox = this.element.querySelector("#mtg-dialog-image");
        this.dialogTitleBox = this.element.querySelector("#mtg-dialog-title");
        this.dialogContentBox = this.element.querySelector("#mtg-dialog-content");
        this.buttonGroupBox = this.element.querySelector("#mtg-dialog-btn-group");

        // 如果需要背景弹窗组件
        if(hasMask){
            this.mask = new Mask()
            // 插入mask遮罩组件
            this.mask.appendTo(document.querySelector("#container"))
        }
        // 如果传入图片地址，可为icon、大图
        if(imageUrl){
            this.dialogImageBox.style.background = `url(${imageUrl}) no-repeat center`;
            this.dialogImageBox.style.backgroundSize = "contain";
        }else{
            // 否则不展示
            this.dialogImageBox.classList.add("hide");
        }
        // 图片尺寸大小默认为icon大小
        switch (imageSize) {
            case "1":
                this.dialogImageBox.classList.add("mtg-dialog-image-size-1");
                break;
            case "2":
                this.dialogImageBox.classList.add("mtg-dialog-image-size-2");
                break;
            case "3":
                this.dialogImageBox.classList.add("mtg-dialog-image-size-3");
                break;
            default:
                this.dialogImageBox.classList.add("mtg-dialog-image-size-1");
        }
        // 如果title传入，则插入title，如果没传入，则不展示，不占位
        if(title){
            this.dialogTitleBox.innerHTML = title;
        }else{
            this.dialogTitleBox.classList.add("hide");
        }
        // 如果content传入，则创建content区域，否则隐藏，不占位，支持字符串、html区块、或其他组件
        if(content){
            if (typeof content === 'string') {
                this.dialogContentBox.innerHTML = content
            } else if (content instanceof HTMLElement) {
                this.dialogContentBox.appendChild(content)
            } else if (content instanceof VisibleComponent) {
                this.dialogContentBox.appendChild(content.element)
            }
        }else{
            this.dialogTitleBox.classList.add("hide");
        }
        if(buttonGroup && buttonGroup.length > 0){
            this.initButtonGroup(buttonGroup)
        }else{
            this.buttonGroupBox.classList.add("hide");
        }
    }

    initButtonGroup(buttonGroup) {
        let btnLength = buttonGroup.length;
        switch (btnLength) {
            case 1:
                this.buttonGroupBox.classList.add("one-btn");
                break;
            case 2:
                this.buttonGroupBox.classList.add("two-btn");
                break;
            default:
                this.buttonGroupBox.classList.add("two-btn");
        }
        buttonGroup.forEach(config => {
            const btn = new Button(config)
            btn.appendTo(this.buttonGroupBox)
        })
    }

    // 允许传入毫秒数，几秒后展示弹窗
    show(duration) {
        if (duration) {
            setTimeout(() => {
                super.show()
                this.mask && this.mask.show();
            }, duration)
        }else{
            super.show()
            this.mask && this.mask.show()
        }
    }

    // 允许传入毫秒数，几秒后隐藏弹窗
    hide(duration) {
        if (duration) {
            setTimeout(() => {
                super.hide()
                this.mask && this.mask.hide()
            }, duration)
        }else{
            super.hide()
            this.mask && this.mask.hide()
        }
    }
}

export default Dialog